<script>
  import DropDown from '../DropDown.svelte';
  import AddTaskModal from '../AddTaskModal.svelte';
  import EditTaskModal from '../EditTaskModal.svelte';
  import GridSearch from '../GridSearch.svelte';
  import { Modal } from 'bootstrap';
  import DataTable from '../DataTable/DataTable.svelte';
  import { client } from 'root/api/index.js';
  import { onMount, getContext, setContext, onDestroy } from 'svelte';
  import TaskReasonModal from '../TaskReasonModal.svelte';
  import TaskChangeAssignee from '../TaskChangeAssignee.svelte';
  import TaskAssigneeFilter from './TaskAssigneeFilter.svelte';
  import DatePicker from '../Flatpickr/DatePicker.svelte';
  import { cloneArray, getValueBySearchValue } from 'components/Helper.js';
  import { Popover } from 'bootstrap';
  import ReadMore from 'components/ReadMore/ReadMore.svelte';
  import { dashboardData, getDashboardData, setDashboardData } from '../../stores/dashboard.js';
  import { authStore, getUserInfo } from '../../stores/auth';
  import { masterData, getMasterData } from '../../stores/masterData';
  import ProgressBar from '../Progress.svelte';
  import ReportFilter from './ReportFilter.svelte';

  export let dashboardLeftObj;
  export let setDashboardFilter;
  let fromToRange = '';
  let initialFromToRange = '';
  let filterSelected = false;
  const showDialog = getContext('showDialog');
  let columnLoaded = false;
  let taskReasonModal;
  let taskChangeAssigneeModal;
  let openDueDateModal;
  let initialBoardDateModal;
  let changePriorityModal;
  let changeRiskRankModal;
  let changeTaskStatusModal;
  let changeComplianceStatusModal;

  import { downloadCsvFile, searchKeyByValue, configItem } from 'components/Helper.js';
  import OpenDueDateModal from './../../components/OpenDueDateModal.svelte';
  import InitialBoardDateModal from './../../components/InitialBoardDateModal.svelte';
  import ChangePriorityModal from './../../components/ChangePriorityModal.svelte';
  import ChangeTaskStatusModal from './../../components/ChangeTaskStatusModal.svelte';
  import ChangeRiskRankModal from './../../components/ChangeRiskRankModal.svelte';
  import ChangeComplianceStatusModal from './../../components/ChangeComplianceStatusModal.svelte';

  const downloadCsv = (exportType) => {
    let filenName = 'basic task list export.csv';
    if (exportType == 'exportsubtask') {
      filenName = 'detailed task list export.csv';
    } else if (exportType == 'exportcollabrator') {
      filenName = 'task collaboration export.csv';
    }
    client
      .exportTaskList({
        ...extraFilter,
        exportType,
      })
      .then(async (result) => {
        // downloadCsvFile(result, "tasks.csv");
        downloadCsvFile(result, filenName);
      });
  };
  let datatableRef;
  let scrollRef;
  let checkBoxSelected = false;
  const handleCheckbox = (e) => {
    checkBoxSelected = e.target.checked;
    if (checkBoxSelected) {
      selectedTasks = datatableRef.getValues().map((item) => {
        return { id: item.id, unitId: item.unitId };
      });
    } else {
      selectedTasks = [];
    }
  };

  let idObj = {
    key: 'id',
    label: 'Id',
    sortable: true,
    checked: true,
    handleCheckbox: handleCheckbox,
    width: 20,
    extraClass: 'first-col',
  };

  let allColumns = [
    idObj,
    {
      key: 'priority',
      label: 'Priority',
      sortable: true,
      checked: true,
      width: 20,
    },
    {
      key: 'riskRank',
      label: 'Risk Rank',
      sortable: true,
      checked: false,
      width: 30,
    },
    {
      key: 'unitName',
      label: 'Business Unit',
      sortable: true,
      checked: true,
      width: 140,
    },
    { key: 'name', label: 'Task', sortable: true, checked: true, width: 0 },
    {
      key: 'progress',
      label: 'Progress',
      sortable: true,
      checked: true,
      width: 120,
    },
    {
      key: 'purpose',
      label: 'Purpose',
      sortable: true,
      checked: true,
      width: 0,
    },
    {
      key: 'requirement',
      label: 'Requirement',
      sortable: true,
      checked: true,
      width: 0,
    },
    {
      key: 'responsibleParty',
      label: 'Responsible Party',
      sortable: true,
      checked: true,
      width: 140,
    },
    {
      key: 'assigneeUserName',
      label: 'Assignee Name',
      sortable: true,
      checked: true,
      width: 120,
    },
    {
      key: 'collaboratorName',
      label: 'Out For collaborator',
      sortable: true,
      checked: true,
      width: 120,
    },
    {
      key: 'clientName',
      label: 'Client',
      sortable: true,
      checked: true,
      width: 120,
    },
    {
      key: 'clientFundProfileName',
      label: 'Funds',
      sortable: true,
      checked: true,
      width: 120,
    },
    {
      key: 'unitProjectName',
      label: 'Internal',
      sortable: true,
      checked: true,
      width: 120,
    },
    {
      key: 'openDate',
      label: 'Open Date',
      sortable: true,
      checked: true,
      width: 90,
    },
    {
      key: 'dueDate',
      label: 'Due Date',
      sortable: true,
      checked: true,
      width: 90,
    },
    {
      key: 'status',
      label: 'Task Status',
      sortable: true,
      checked: true,
      width: 130,
    },
    {
      key: 'complianceStatus',
      label: 'Compliance Status',
      sortable: true,
      checked: false,
      width: 130,
    },
    {
      key: 'completeDate',
      label: 'Completion Date',
      sortable: true,
      checked: true,
      width: 90,
    },
    {
      key: 'completeBy',
      label: 'Completed By',
      sortable: true,
      checked: true,
      width: 80,
    },
    {
      key: 'clone',
      label: 'Clone',
      sortable: false,
      checked: true,
      width: 20,
    },
  ];

  let availableWidth = 0;
  const setColumnUnitWidth = () => {
    let totalWidth = 220;
    columns.map((item) => {
      totalWidth += item.width;
    });
    availableWidth = window.screen.width - totalWidth;
    availableWidth = availableWidth < 100 ? 100 : availableWidth;
    let totalColumn = 0;
    if (searchKeyByValue(columns, 'key', 'purpose') != -1) {
      totalColumn++;
    }
    if (searchKeyByValue(columns, 'key', 'name') != -1) {
      totalColumn++;
    }
    if (searchKeyByValue(columns, 'key', 'requirement') != -1) {
      totalColumn++;
    }
    if (totalColumn > 0) {
      availableWidth /= totalColumn;
    }
  };

  let columns = [...allColumns];
  let defaultFilter = {
    searchKeyword: '',
    schedule: 0,
    taskType: '',
    outForCollabrator: 0,
    overdue: 0,
    requireReview: 0,
    noInitialBoardDate: 0,
    isManager: 0,
    unitProjectId: '',
    unitRegistrationTypeIds: [],
    taskActivityTypes: [],
    task_category: [],
    taskComplianceStatusType: [],
    units: [],
    users: [],
    priority: [],
    taskRiskRankType: [],
    taskServiceType: [],
    clients: [],
    status: 1,
    fromDate: '',
    toDate: '',
    initialFromDate: '',
    initialToDate: '',
    requestKey: 0,
    comeFrom: '',
    progress: [],
  };
  let extraFilter = { ...defaultFilter };

  const loadAction = () => {
    if (getMasterData() && getUserInfo()) {
      let userRoleId = getUserInfo().roleId;
      let userRoles = getMasterData().userRoleId;
      let action = [];
      action.push({ id: 1, text: 'Change Assignee' });
      // if(extraFilter.status!=2 || (userRoles.admin == userRoleId || userRoles.unit_admin == userRoleId)){
      action.push({ id: 2, text: 'Delete Task' });
      // }
      action.push({ id: 3, text: 'Complete Task' });
      action.push({ id: 4, text: 'Change Open & Due Date' });
      action.push({ id: 12, text: 'Change Initial Board Date' });
      action.push({ id: 5, text: 'Change Priority' });
      action.push({ id: 11, text: 'Change Risk Rank' });
      action.push({ id: 9, text: 'Change Task Status' });
      action.push({ id: 10, text: 'Change Compliance Status' });
      action.push({ id: 6, text: 'Undo Collaborator' });
      action.push({ id: 7, text: 'Review Completed' });
      if (extraFilter.status == 2) {
        action.push({ id: 8, text: 'Change Completion Date' });
      }
      bulkAction = action;
    }
    return true;
  };

  $: extraFilter && loadAction() && filterData();
  $: extraFilter && showFilterButton();

  let filterButton = false;
  const showFilterButton = () => {
    filterButton =
      JSON.stringify({ ...defaultFilter, units: [], requestKey: 0 }) !=
      JSON.stringify({ ...extraFilter, units: [], requestKey: 0 });
  };
  let totalRecords = '';
  let totalCount = '';

  let totalProgress = '';

  let getCount = () => {
    let queries = {};
    client
      .taskCount({
        ...queries,
        ...defaultFilter,
        status: extraFilter.status,
        units: extraFilter.units,
        isManager: extraFilter.isManager,
        isTotalCount: 1,
      })
      .then((result) => {
        totalRecords = result.data.pagination.totalCount;
      });
  };

  let getListCount = () => {
    let queries = {};
    totalCount = '';
    totalProgress = '';
    client
      .taskList(50, 1, {
        ...queries,
        ...extraFilter,
      })
      .then((result) => {
        totalCount = result.totalCount;
        totalProgress = result.extraData.totalProgress;
      });
  };

  let getData = (queries) => {
    checkBoxSelected = false;
    return client.taskList(50, 1, {
      ...queries,
      ...extraFilter,
      taskIds,
    });
  };

  let assignee = [];

  let taskType = [
    { id: 1, text: 'Client' },
    { id: 2, text: 'Internal' },
  ];

  let bulkAction = [];

  let status = [
    { id: 1, text: 'Open' },
    { id: 2, text: 'Completed' },
  ];

  // Payload parameter coming from API
  // First 3 statuses (Open, Complete and Sheduled), should not appear in the task status filter values
  const excludedStatus = configItem.allTaskStatus
    .filter((item) => ['Scheduled', 'Open', 'Complete'].includes(item.name))
    .map((item) => item.id);
  let task_category = configItem.allTaskStatus.filter((item) => !excludedStatus.includes(item.id));
  let taskComplianceStatusType = configItem.allComplianceStatus;
  let taskRiskRankType = configItem.riskRank;
  let taskServiceType = [];

  let id = 0;
  let addTaskModal;
  let editTaskModal;

  export const addTask = (params) => {
    id = 0;
    addTaskModal.show(params);
  };
  let configProgress = [];
  const unsubscribeMasterData = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        let userRoleId = getUserInfo().roleId;
        let userRoles = getMasterData().userRoleId;
        configProgress = cloneArray(getMasterData().progress_type);
        loadAction();
      }
    });
  });

  const editTask = (taskId, comeFrom) => {
    editTaskModal.show(taskId, comeFrom);
  };

  let configPriority = cloneArray(configItem.priority);
  // let configProgress=configItem.progress
  let unitUsers = [];
  let clientUnitUsers = [];
  let registrationTypes = [];
  let taskActivityTypes = [];
  const getUnitDetail = async (comeFrom) => {
    let unitIds = [...extraFilter.units];
    unitIds.map((item) => {
      item.unitId = item.id;
      return item;
    });
    client
      .unitUsers({
        units: unitIds,
        inactiveCondition: 'N',
        inactiveUnitCondition: 'N',
      })
      .then((response) => {
        let detail = response.data;
        unitUsers = detail.users.map((item) => {
          item.name = item.firstName + ' ' + item.lastName;
          item.checked = searchKeyByValue(extraFilter.users, 'id', item.userId) != -1;
          return item;
        });
      });
    client.getUnitProject({ units: unitIds }).then((response) => {
      extraFilter.unitProjectId = '';
      projects = response.data.projects;
    });

    client.unitTaskClients({ units: unitIds }).then((response) => {
      clientUnitUsers = response.data.clients.map((item) => {
        item.checked = searchKeyByValue(extraFilter.clients, 'id', item.id) != -1;
        return item;
      });
    });

    if (unitIds.length > 0) {
      const result = await client.sowServiceType({ units: unitIds });
      taskServiceType = (result?.data?.payload || [])?.map?.((item) => {
        item.checked = extraFilter.taskServiceType?.some?.((service) => service.id === item.id);
        return item;
      });

      client.taskTemplateFilter({ units: unitIds }).then((response) => {
        taskActivityTypes = [
          { id: -1, name: 'No Type' },
          ...response.data.taskActivityTypes,
        ]?.map?.((item) => {
          item.checked = extraFilter.taskActivityTypes?.some?.(
            (activity) => activity.id === item.id,
          );
          return item;
        });
        registrationTypes = response.data.registrationTypes;

        if (comeFrom != undefined && comeFrom == 'filterSelected') {
          let oldRegistrationTypes = cloneArray(registrationTypes).map((userItem) => {
            userItem.checked =
              extraFilter.unitRegistrationTypeIds.length > 0 &&
              searchKeyByValue(extraFilter.unitRegistrationTypeIds, 'id', userItem.id) !== -1;
            return userItem;
          });
          let oldTaskActivityTypes = cloneArray(taskActivityTypes).map((userItem) => {
            userItem.checked =
              extraFilter.taskActivityTypes.length > 0 &&
              searchKeyByValue(extraFilter.taskActivityTypes, 'id', userItem.id) !== -1;
            return userItem;
          });
          setTimeout(() => {
            registrationTypes = oldRegistrationTypes;
            taskActivityTypes = oldTaskActivityTypes;
          }, 1000);
        }
      });
    }

    // setDashboardData({
    //   ...getDashboardData(),
    //   // units:extraFilter.units,
    //   clients:extraFilter.clients.length>0?extraFilter.clients:[],

    // })
    // clientUnitUsers=clientUnitUsers
  };

  let searchTimeout;
  let searchCloneTimeout;
  let firstTimeGridLoad = true;
  let ignoreRequest = false;
  let filterData = () => {
    if (ignoreRequest) {
      return false;
    }
    if (searchTimeout != undefined) {
      clearTimeout(searchTimeout);
    }
    if (searchCloneTimeout != undefined) {
      clearTimeout(searchCloneTimeout);
    }
    searchTimeout = setTimeout(() => {
      if (datatableRef != undefined) {
        getCount();
        getListCount();
        if (firstTimeGridLoad) {
          firstTimeGridLoad = false;
          searchCloneTimeout = setTimeout(() => {
            initPopupOver();
          }, 400);
          return false;
        }
        selectedTasks = [];
        datatableRef.initializeState();
        searchCloneTimeout = setTimeout(() => {
          initPopupOver();
        }, 400);
      }
    }, 500);
  };

  let selectedTasks = [];
  let assignType = 1;
  let projects = [];

  let selectedTypeId;
  let comeFromDetail = false;

  // Task ids series - will show the heading options only based on these ids
  const updateAssignee = 1;
  const deleteTask = 2;
  const updateRiskRank = 11;

  // Popup heading variations
  const setOptionHeading = (optionId) => {
    const headersTaskSeries = [updateAssignee, deleteTask, updateRiskRank];
    const complianceStatusTaskId = 10;
    if (headersTaskSeries.includes(optionId))
      return 'If this task is part of a series, do you want to:';
    if (optionId === complianceStatusTaskId)
      return 'If this task is part of a series, it will only be changed here. No other linked instances will be changed.';
    return '';
  };
  const taskBulkAction = (typeId, comeFromBulk) => {
    comeFromDetail = comeFromBulk;
    selectedTypeId = typeId;
    if (selectedTasks.length > 0) {
      if (typeId == 1) {
        let unitIdSelected = selectedTasks[0].unitId;
        let allUnitSame = true;
        selectedTasks.map((item) => {
          if (item.unitId != unitIdSelected) {
            allUnitSame = false;
          }
        });
        if (allUnitSame == false) {
          showDialog({
            title: '',
            message: 'Please select tasks from 1 unit at a time to bulk change assignee.',
          });
          return false;
        }
      }
      showDialog({
        isDeleteModel: typeId == 2,
        isTopHeading: typeId == 6 ? 'N' : 'Y',
        type: 'confirm',
        title: typeId == 6 ? 'Are you sure ?' : '',
        message:
          typeId == 6
            ? 'This will undo any open/pending collaboration submissions.'
            : 'Are you sure ?',
        optionHeading: setOptionHeading(typeId),
        options: [updateAssignee, updateRiskRank].includes(typeId)
          ? cloneArray(configItem.assignTypes)
          : typeId == deleteTask
            ? cloneArray(configItem.deleteAssignTypes)
            : [],
        okFunc: (e) => {
          //change assignee
          if (typeId == 1 || typeId == 2) {
            assignType = e.selectedOptions.value;
          }
          if (typeId == 1) {
            let unitIdSelected = selectedTasks[0].unitId;
            client
              .unitUsers({
                units: [
                  {
                    id: unitIdSelected,
                    unitId: unitIdSelected,
                  },
                ],
              })
              .then((response) => {
                let detail = response.data;
                taskChangeAssigneeModal.showModal({
                  unitUsers: detail.users,
                  selectedTasks,
                });
              });
          }
          //delete task
          if (typeId == 8) {
            openDueDateModal.show({
              comeFrom: 'bulk',
              dateType: 'completeDate',
              tasks: selectedTasks,
            });
          }
          if (typeId == 4) {
            openDueDateModal.show({
              comeFrom: 'bulk',
              dateType: 'openDate',
              tasks: selectedTasks,
            });
          }
          // initial board date
          if (typeId == 12) {
            initialBoardDateModal.show({
              tasks: selectedTasks,
            });
          }
          //priority task
          if (typeId == 5) {
            changePriorityModal.show({
              tasks: selectedTasks,
              priority: 2,
            });
          }
          // change risk rank
          if (typeId == 11) {
            changeRiskRankModal.show({
              tasks: selectedTasks,
              riskRank: 2,
              assignType: e.selectedOptions.value,
            });
          }
          // change task status
          if (typeId == 9) {
            changeTaskStatusModal.show({
              tasks: selectedTasks,
            });
          }
          // change compliance status
          if (typeId == 10) {
            changeComplianceStatusModal.showModal({
              selectedTasks,
            });
          }
          //delete task
          if (typeId == 2 || typeId == 6 || typeId == 7) {
            taskReasonModal.showModal(typeId);
          }
          //comeplete task
          if (typeId == 3) {
            client
              .taskComplete({ tasks: selectedTasks })
              .then(async (result) => {
                selectedTasks = [];
                filterData();
              })
              .catch((err) => {
                showDialog({
                  message: err.message,
                  isHtmlMessage: true,
                });
              });
          }
        },
      });
    } else {
      showDialog({
        title: '',
        message: 'Please select task',
      });
    }
  };

  setContext('taskAction', (params) => {
    if (params.type == 'saveTask') {
      filterData();
      if (params.id > 0 && !(params.values != undefined && params.values.status == 2)) {
        return;
      }
    }
    if (params.type == 'deleteTask') {
      selectedTasks = [{ id: params.id }];
      taskBulkAction(2, true);
      return;
    }
    if (editTaskModal != undefined) {
      editTaskModal.hide();
    }
    if (addTaskModal != undefined) {
      addTaskModal.hide();
    }
  });

  const unsubscribe = dashboardData.subscribe((dataState) => {
    client.checkAuth().then(() => {
      if (dataState != undefined) {
        let state = { ...dataState };
        let oldExtraFilter = { ...extraFilter };
        let loadUnit = false;
        if (JSON.stringify(oldExtraFilter.units) != JSON.stringify(state.units)) {
          loadUnit = true;
          oldExtraFilter.units = [...state.units];
        }
        if (JSON.stringify(oldExtraFilter.clients) != JSON.stringify(state.clients)) {
          oldExtraFilter.clients = [...state.clients];
        }
        if (JSON.stringify(oldExtraFilter.users) != JSON.stringify(state.users)) {
          oldExtraFilter.users = [...state.users];
        }
        oldExtraFilter.taskComplianceStatusType = state.taskComplianceStatusType;
        oldExtraFilter.taskRiskRankType = state.taskRiskRankType;
        const filteredTaskStatus = (state.task_category || [])?.filter?.(
          (item) => !excludedStatus.includes(item.id),
        );
        oldExtraFilter.task_category = filteredTaskStatus;
        oldExtraFilter.taskServiceType = state.taskServiceType;
        oldExtraFilter.taskActivityTypes = state.taskActivityTypes;
        oldExtraFilter.requestKey++;
        oldExtraFilter.fromDate = state.fromDate;
        oldExtraFilter.toDate = state.toDate;
        if (state.fromDate != '' && state.toDate != '') {
          fromToRange = state.fromDate + ' to ' + state.toDate;
        }
        if (state.initialFromDate && state.initialToDate) {
          initialFromToRange = state.initialFromDate + ' to ' + state.initialToDate;
        }
        oldExtraFilter.isManager = state.isManager;
        extraFilter = { ...oldExtraFilter };
        if (loadUnit) {
          getUnitDetail();
        } else {
          unitUsers = unitUsers.map((item) => {
            item.checked = searchKeyByValue(extraFilter.users, 'id', item.userId) != -1;
            return item;
          });
          clientUnitUsers = clientUnitUsers.map((item) => {
            item.checked = searchKeyByValue(extraFilter.clients, 'id', item.id) != -1;
            return item;
          });
        }
        if (loadDataTable == false) {
          loadDataTableTimeout && clearTimeout(loadDataTableTimeout);
          loadDataTableTimeout = setTimeout(
            () => {
              loadDataTable = true;
            },
            window.location.hash != '' ? 1000 : 0,
          );
        }
      }
    });
  });
  onDestroy(() => {
    unsubscribe();
    unsubscribeMasterData();
  });
  let loadDataTableTimeout;
  let taskIds;
  let loadDataTable = false;
  export const checkUrl = (params) => {
    if (params.action == 'addTask') {
      addTask(params);
    } else if (params.action == 'viewTask') {
      if (params.clientId != undefined) {
        extraFilter.clients = [{ id: params.clientId }];
      }
      if (params.taskIds != undefined) {
        taskIds = params.taskIds;
        extraFilter.isManager = getUserInfo().roleId == 4 ? 0 : 1;
        extraFilter.status = 0;
        extraFilter.requestKey = extraFilter.requestKey + 1;
        setTimeout(() => {
          //set default filter reset when task id passed
          ignoreRequest = true;
          taskIds = undefined;
          extraFilter.isManager = 0;
          extraFilter.status = 1;
          setTimeout(() => {
            ignoreRequest = false;
          }, 250);
        }, 1000);
      }
      if (params.overdue != undefined) {
        extraFilter.overdue = params.overdue;
      }
    } else if (params.action == 'editTask') {
      editTask(params.taskId, params.comeFrom);
    } else if (params.action == 'managerTask') {
      extraFilter = { ...extraFilter, isManager: 1 };
    } else if (params.action == 'openTask' && params.userId != undefined) {
      extraFilter = {
        ...extraFilter,
        users: [{ id: params.userId, userId: params.userId }],
        units: [{ id: params.unitId, unitId: params.unitId }],
      };
      setDashboardData({
        ...getDashboardData(),
        isManager: 1,
        units: [{ id: params.unitId, unitId: params.unitId }],
        users: [{ id: params.userId, userId: params.userId }],
        taskServiceType: [],
        taskActivityTypes: [],
      });
    } else if (params.action == 'openTask' && params.openTaskId != undefined) {
      editTask(params.openTaskId, params.comeFrom);
    }
  };

  const initPopupOver = () => {
    var tooltipElements = document.querySelectorAll('.popover.show');
    tooltipElements.forEach(function (el) {
      var existing = Popover.getInstance(el);
      if (existing) {
        existing.dispose();
      }
      el.remove();
    });
    var elements = document.querySelectorAll('.clone_popup');
    elements.forEach(function (el) {
      new Popover(el, { container: el.parentElement, animation: false });
    });
  };

  onMount(() => {
    getUnitDetail();

    client.taskGridColumnList().then((response) => {
      let oldColumns = [];
      let dbData = response.data.payload;
      let oldAllColumns = [...allColumns];
      for (var i in oldAllColumns) {
        let dbKey = searchKeyByValue(dbData, 'column_name', oldAllColumns[i].key);
        oldAllColumns[i].checked = true;
        if (dbKey !== -1) {
          if (dbData[dbKey].active == 1) {
            oldColumns.push(oldAllColumns[i]);
          } else {
            oldAllColumns[i].checked = false;
          }
        }
      }

      allColumns = oldAllColumns;
      columns = oldColumns;
      columnLoaded = true;
      setColumnUnitWidth();
    });
  });
  export let showClientModal;
  const getTaskStatusTitle = () => {
    let key = searchKeyByValue(status, 'id', extraFilter.status);
    if (key != -1) {
      return status[key].text;
    } else {
      return 'All Status';
    }
  };
  let showBulkOption = true;
  let heighlightTaskIds = [];
  let heighlightType = '';
  const resetFilter = () => {
    configPriority = cloneArray(configItem.priority);
    configProgress = cloneArray(getMasterData()?.progress_type || []);
    filterSelected = false;
    let oldUnitUsers = unitUsers;
    oldUnitUsers.map((item) => (item.checked = false));
    unitUsers = oldUnitUsers;
    extraFilter = {
      ...extraFilter,
      users: [],
      priority: [],
      status: 1,
      outForCollabrator: 0,
      overdue: 0,
      requireReview: 0,
      taskType: '',
      noInitialBoardDate: 0,
      fromDate: '',
      toDate: '',
      initialFromDate: '',
      initialToDate: '',
      unitProjectId: '',
      unitRegistrationTypeIds: [],
      taskActivityTypes: [],
      task_category: [],
      taskComplianceStatusType: [],
      taskRiskRankType: [],
      taskServiceType: [],
      clients: [],
      progress: [],
      searchKeyword: '',
    };
    registrationTypes = registrationTypes.map((item) => {
      item.checked = false;
      return item;
    });
    task_category = task_category.map((item) => {
      item.checked = false;
      return item;
    });
    taskComplianceStatusType = taskComplianceStatusType.map((item) => {
      item.checked = false;
      return item;
    });
    taskRiskRankType = taskRiskRankType.map((item) => {
      item.checked = false;
      return item;
    });
    taskActivityTypes = taskActivityTypes.map((item) => {
      item.checked = false;
      return item;
    });
    taskServiceType = taskServiceType.map((item) => {
      item.checked = false;
      return item;
    });
    setDashboardData({
      ...getDashboardData(),
      clients: [],
      users: [],
      fromDate: '',
      toDate: '',
      initialFromDate: '',
      initialToDate: '',
      taskComplianceStatusType: [],
      taskRiskRankType: [],
      task_category: [],
      taskServiceType: [],
      taskActivityTypes: [],
    });
  };
</script>

<div class="filter-content top-menu-filter">
  <div class="d-flex flex-row mb-2 justify-content-between">
    <div class="d-flex flex-wrap flex-row">
      <TaskAssigneeFilter
        showDate={true}
        fromToRange={fromToRange}
        initialFromToRange={initialFromToRange}
        unitUsers={unitUsers}
        clientUnitUsers={clientUnitUsers}
        setDashboardFilter={setDashboardFilter}
        extraFilter={extraFilter}
        dashboardLeftObj={dashboardLeftObj}
        changeFilter={(filter) => {
          extraFilter = {
            ...extraFilter,
            ...filter,
          };
        }}
        type="1"
        showSaveButton={filterButton}
        filter={extraFilter}
        filterSelected={filterSelected}
        on:filterSave={(item) => {
          filterButton = item.detail;
        }}
        on:filterSelected={(item) => {
          filterSelected = true;
          extraFilter = item.detail.filterData;
          fromToRange = extraFilter.fromDate + ' to ' + extraFilter.toDate;
          if (extraFilter.initialFromDate && extraFilter.initialToDate) {
            initialFromToRange = extraFilter.initialFromDate + ' to ' + extraFilter.initialToDate;
          }
          taskComplianceStatusType = taskComplianceStatusType?.map?.((item) => {
            item.checked = extraFilter.taskComplianceStatusType?.some?.(
              (compliance) => compliance.id === item.id,
            );
            return item;
          });
          taskRiskRankType = taskRiskRankType?.map?.((item) => {
            item.checked = extraFilter.taskRiskRankType?.some?.((risk) => risk.id === item.id);
            return item;
          });
          task_category = task_category?.map?.((item) => {
            item.checked = extraFilter.task_category?.some?.((taskStat) => taskStat.id === item.id);
            return item;
          });
          getUnitDetail('filterSelected');
          let oldUnitUsers = cloneArray(unitUsers).map((userItem) => {
            userItem.checked =
              extraFilter.users.length > 0 &&
              searchKeyByValue(extraFilter.users, 'userId', userItem.userId) !== -1;
            return userItem;
          });

          let oldClientUnitUsers = cloneArray(clientUnitUsers).map((userItem) => {
            userItem.checked =
              extraFilter.clients.length > 0 &&
              searchKeyByValue(extraFilter.clients, 'id', userItem.id) !== -1;
            return userItem;
          });
          let oldConfigPriority = cloneArray(configPriority).map((userItem) => {
            userItem.checked =
              extraFilter.priority.length > 0 &&
              searchKeyByValue(extraFilter.priority, 'id', userItem.id) !== -1;
            return userItem;
          });
          let oldConfigProgress = cloneArray(configProgress).map((userItem) => {
            userItem.checked =
              extraFilter.progress.length > 0 &&
              searchKeyByValue(extraFilter.progress, 'id', userItem.id) !== -1;
            return userItem;
          });
          setTimeout(() => {
            let notFoundUsers = extraFilter.users
              .filter((userItem) => {
                let userKey = searchKeyByValue(unitUsers, 'userId', userItem.id);
                if (
                  extraFilter.units.length > 0 &&
                  (userKey == -1 ||
                    (unitUsers[userKey] &&
                      unitUsers[userKey].units.filter((item) => item.active == 0).length > 0))
                ) {
                  return true;
                }
                return false;
              })
              .map((userData) => {
                return userData.name;
              })
              .join(', ');
            let notFoundClient = extraFilter.clients
              .filter((userItem) => {
                return searchKeyByValue(clientUnitUsers, 'id', userItem.id) == -1;
              })
              .map((userData) => {
                return userData.name;
              })
              .join(', ');
            if (notFoundUsers != '' || notFoundClient != '') {
              let message = '';
              if (notFoundUsers != '') {
                message +=
                  ' Following users which are part of your report are no longer active:  ' +
                  notFoundUsers;
              }
              if (notFoundClient != '') {
                if (notFoundUsers != '') {
                  message += '<br /> ';
                }
                message +=
                  ' Following clients which are part of your report are no longer active:  ' +
                  notFoundClient;
              }
              showDialog({
                message,
                yesText: 'Continue',
              });
            }
          }, 500);
          setDashboardData({
            ...getDashboardData(),
            taskComplianceStatusType: extraFilter.taskComplianceStatusType,
            taskRiskRankType: extraFilter.taskRiskRankType,
            task_category: extraFilter.task_category,
            taskServiceType: extraFilter.taskServiceType,
            taskActivityTypes: extraFilter.taskActivityTypes,
            units: extraFilter.units,
            isManager: extraFilter.isManager,
            clients: extraFilter.clients.length > 0 ? extraFilter.clients : [],
            users: extraFilter.users.length > 0 ? extraFilter.users : [],
            fromDate: extraFilter.fromDate,
            toDate: extraFilter.toDate,
          });
          setTimeout(() => {
            // unitUsers=oldUnitUsers
            // clientUnitUsers=oldClientUnitUsers
            configPriority = oldConfigPriority;
            configProgress = oldConfigProgress;
            fromToRange = extraFilter.fromDate + ' to ' + extraFilter.toDate;
            if (extraFilter.initialFromDate && extraFilter.initialToDate) {
              initialFromToRange = extraFilter.initialFromDate + ' to ' + extraFilter.initialToDate;
            }
          }, 500);
        }}
        on:clearFilter={() => {
          resetFilter();
        }}
      />
    </div>

    <GridSearch
      btnExport={true}
      comeFrom="taskList"
      value={extraFilter.searchKeyword}
      handleInput={(e) => {
        extraFilter.searchKeyword = e.target.value;
      }}
      selectedTasks={selectedTasks}
      onAction={(params) => {
        if (params == 'export' || params == 'exportsubtask' || params == 'exportcollabrator') {
          downloadCsv(params);
        }
        if (params == 'delete') {
          alert('delete');
        }
      }}
      placeholder="Search Task"
    />
  </div>

  <div class="d-flex flex-row">
    <div class="left-action-bar w-100">
      <div class="d-flex flex-wrap flex-row align-items-center">
        <DropDown
          title={extraFilter.taskType == undefined || extraFilter.taskType == ''
            ? 'Client/Internal'
            : taskType[extraFilter.taskType - 1].text}
          option={taskType}
          Style="select-block"
          titleChanged={true}
          on:onSelect={(event) => {
            extraFilter.taskType = event.detail.id;
            extraFilter.unitProjectId = 0;
          }}
        />
        {#if extraFilter.taskType == 2}
          <DropDown
            defaultTitle="All Project"
            title={extraFilter.unitProjectId != undefined &&
            extraFilter.unitProjectId > 0 &&
            searchKeyByValue(projects, 'id', extraFilter.unitProjectId) != -1
              ? projects[searchKeyByValue(projects, 'id', extraFilter.unitProjectId)].name
              : 'All Project'}
            searchbox={true}
            option={projects}
            Style="select-block projects-block"
            titleChanged={true}
            on:onSelect={(event) => {
              extraFilter.unitProjectId = event.detail.id;
            }}
          />
        {/if}
        <DropDown
          titleChanged={true}
          checkbox={false}
          active={false}
          title={getTaskStatusTitle(extraFilter.status)}
          option={status}
          Style="select-block"
          on:onSelect={(event) => {
            task_category = task_category.map((cv) => ({
              ...cv,
              checked: false,
            }));
            extraFilter.status = event.detail.id != undefined ? event.detail.id : 1;
            if (extraFilter.status == 2) {
              extraFilter = {
                ...extraFilter,
                overdue: 0,
                outForCollabrator: 0,
                requireReview: 0,
              };
            }
            setDashboardData({
              ...getDashboardData(),
              task_category: [],
            });
          }}
        />
        {#if extraFilter.status == 1}
          <DropDown
            searchbox={true}
            checkbox={true}
            checkedFields="checked"
            title="Task Status"
            option={task_category}
            Style="select-block"
            titleChanged={true}
            removeIcon={true}
            on:onClear={() => {
              setDashboardData({
                ...getDashboardData(),
                task_category: [],
              });
            }}
            on:onSelect={(event) => {
              setDashboardData({
                ...getDashboardData(),
                task_category: event.detail,
              });
            }}
          />
          <div class="checkbox c-checkbox px-1 filters">
            <label class="font-size-12"
              ><input
                type="checkbox"
                checked={extraFilter.overdue == 1}
                on:change={(event) => (extraFilter.overdue = event.target.checked ? 1 : 0)}
              />
              <span class="check-img"></span>
              Overdue
            </label>
          </div>

          <div
            class="checkbox c-checkbox px-1 filters clone_popup"
            data-bs-placement="top"
            data-bs-toggle="popover"
            data-bs-trigger="hover focus"
            data-bs-content="These are tasks that the assignee has submitted to a collaborator."
          >
            <label class="font-size-12"
              ><input
                type="checkbox"
                checked={extraFilter.outForCollabrator == 1}
                on:change={(event) => {
                  extraFilter.outForCollabrator = event.target.checked ? 1 : 0;
                  var elements = document.querySelectorAll('.popover.show');
                  elements.forEach(function (el) {
                    el.remove();
                  });
                }}
              />
              <span class="check-img"></span>
              Out for Collaborator
            </label>
          </div>

          <div class="checkbox c-checkbox px-1 filters">
            <label class="font-size-12"
              ><input
                type="checkbox"
                checked={extraFilter.requireReview == 1}
                on:change={(event) => (extraFilter.requireReview = event.target.checked ? 1 : 0)}
              />
              <span class="check-img"></span>
              Requires Review
            </label>
          </div>
        {/if}

        <!-- No Initial Board Date checkbox -->
        <div class="checkbox c-checkbox px-1 filters">
          <label class="font-size-12"
            ><input
              type="checkbox"
              checked={extraFilter.noInitialBoardDate == 1}
              on:change={(event) => {
                extraFilter.noInitialBoardDate = event.target.checked ? 1 : 0;
                extraFilter.initialFromDate = '';
                extraFilter.initialToDate = '';
                initialFromToRange = '';
                setDashboardData({
                  ...getDashboardData(),
                  initialFromDate: '',
                  initialToDate: '',
                });
              }}
            />
            <span class="check-img"></span>
            No Initial Board Date
          </label>
        </div>

        {#if extraFilter.status == 1}
          <DropDown
            showIcon={true}
            checkbox={true}
            deleteSelected={true}
            titleChanged={false}
            active={true}
            title="Priority"
            checkedFields="checked"
            removeIcon={true}
            on:onClear={(event) => {
              extraFilter.priority = [];
            }}
            on:onSelect={(item) => {
              extraFilter.priority = item.detail;
            }}
            option={configPriority}
            Style="select-block"
          />
          <DropDown
            title="Progress"
            checkbox={true}
            titleChanged={true}
            option={configProgress}
            Style="select-block"
            checkedFields="checked"
            removeIcon={true}
            on:onClear={(event) => {
              extraFilter.progress = [];
            }}
            on:onSelect={(item) => {
              extraFilter.progress = item.detail;
            }}
          />
          {#if extraFilter.units.length > 0}
            <DropDown
              searchbox={true}
              checkbox={true}
              checkedFields="checked"
              title="Registration type"
              option={registrationTypes}
              Style="select-block"
              titleChanged={true}
              removeIcon={true}
              on:onClear={(event) => {
                extraFilter.unitRegistrationTypeIds = [];
              }}
              on:onSelect={(event) => {
                extraFilter.unitRegistrationTypeIds = event.detail;
              }}
            />
          {/if}
        {/if}
        <!-- Service Type filter -->
        {#if taskServiceType.length > 0 && extraFilter.units.length > 0}
          <DropDown
            searchbox={true}
            checkbox={true}
            deleteSelected={true}
            titleChanged={false}
            title="Service Type"
            checkedFields="checked"
            removeIcon={true}
            option={taskServiceType}
            Style="select-block"
            on:onClear={() => {
              setDashboardData({
                ...getDashboardData(),
                taskServiceType: [],
              });
            }}
            on:onSelect={(item) => {
              setDashboardData({
                ...getDashboardData(),
                taskServiceType: item.detail,
              });
            }}
          />
        {/if}
        {#if extraFilter.units.length > 0}
          <DropDown
            searchbox={true}
            checkbox={true}
            checkedFields="checked"
            title="Activity Type"
            option={taskActivityTypes}
            Style="select-block"
            titleChanged={true}
            removeIcon={true}
            on:onClear={() => {
              setDashboardData({
                ...getDashboardData(),
                taskActivityTypes: [],
              });
            }}
            on:onSelect={(event) => {
              setDashboardData({
                ...getDashboardData(),
                taskActivityTypes: event.detail,
              });
            }}
          />
        {/if}

        <!-- Risk Rank filter -->
        <DropDown
          showIcon={true}
          checkbox={true}
          deleteSelected={true}
          titleChanged={false}
          active={true}
          title="Risk Rank"
          checkedFields="checked"
          removeIcon={true}
          on:onClear={() => {
            setDashboardData({
              ...getDashboardData(),
              taskRiskRankType: [],
            });
          }}
          on:onSelect={(item) => {
            setDashboardData({
              ...getDashboardData(),
              taskRiskRankType: item.detail,
            });
          }}
          option={taskRiskRankType}
          Style="select-block"
        />

        <!-- Compliance status filter -->
        <DropDown
          searchbox={true}
          checkbox={true}
          checkedFields="checked"
          title="Compliance Status"
          option={taskComplianceStatusType}
          Style="select-block"
          titleChanged={true}
          removeIcon={true}
          on:onClear={() => {
            setDashboardData({
              ...getDashboardData(),
              taskComplianceStatusType: [],
            });
          }}
          on:onSelect={(event) => {
            setDashboardData({
              ...getDashboardData(),
              taskComplianceStatusType: event.detail,
            });
          }}
        />

        <button
          type="button"
          class="p-0 reset-filter color-blue d-flex flex-row align-items-center text-start ms-1 bg-transparent border-0"
          on:click={() => {
            resetFilter();
          }}
        >
          <img
            class="icon-14 me-2"
            alt=""
            src="/images/reset.svg"
          />
          Reset Filter
        </button>
      </div>
      <div class="d-flex flex-wrap flex-row align-items-center">
        {#if showBulkOption}
          <DropDown
            checkbox={false}
            active={true}
            title="Action"
            titleClass="text-primary"
            on:onSelect={(item) => {
              taskBulkAction(item.detail.id);
            }}
            option={bulkAction}
            Style="select-block bulk-action-drop"
          />
        {/if}
      </div>
    </div>

    <div
      class="right-action-content flex-wrap d-flex justify-content-end align-items-center d-flex"
    >
      <div class="d-flex flex-row align-items-center">
        <div class="ms-1 me-2">Total Progress</div>
        <ProgressBar
          progressPer={totalProgress}
          progressPerValue={totalProgress}
        />
        <!-- <ReportFilter
				  showSaveButton={filterButton}
				  filter={extraFilter}
				  type={1}
				  on:onSave={(item)=>{
					filterButton=false;
				  }}
				  /> -->

        <span class="text-nowrap me-2"
          >{totalRecords > 0 && totalCount > 0
            ? '(' + totalCount + ' of ' + totalRecords + ' Tasks)'
            : ''}</span
        >
      </div>
      {#if columnLoaded && showBulkOption}
        <DropDown
          checkbox={true}
          active={false}
          title="Fields"
          option={allColumns.filter((item) => item.key !== 'id')}
          labelFields="label"
          checkedFields="checked"
          Style="select-block "
          dropDownStyle={' dropdown-menu-end right-position'}
          on:onSelect={(item) => {
            let oldColumns = [];
            for (var i in allColumns) {
              if (allColumns[i].key == 'id') {
                oldColumns.push(idObj);
                allColumns[i].checked = true;
              } else if (searchKeyByValue(item.detail, 'key', allColumns[i].key) !== -1) {
                oldColumns.push(allColumns[i]);
                allColumns[i].checked = true;
              } else {
                allColumns[i].checked = false;
              }
            }
            setTimeout(() => {
              initPopupOver();
            }, 500);
            columns = oldColumns;
            client.taskGridColumnSave({ columns: allColumns });
            setColumnUnitWidth();
          }}
        />
      {/if}
    </div>
  </div>
</div>

<div class="page-content table-content p-0">
  <div
    class="tab-content h-100 d-flex flex-column p-3"
    id="myTabContent2"
  >
    <div
      class="tab-pane page-content fade show page-content tasklist-content active"
      id="home2"
      role="tabpanel"
      aria-labelledby="home-tab2"
      bind:this={scrollRef}
    >
      {#if loadDataTable}
        <DataTable
          bind:this={datatableRef}
          columns={columns}
          scrollRef={scrollRef}
          getData={getData}
          datatableCallback={(state) => {
            if (checkBoxSelected) {
              selectedTasks = [
                ...(selectedTasks || []),
                ...(state?.value?.[state.pageNumber] || [])?.map((item) => ({
                  id: item.id,
                  unitId: item.unitId,
                })),
              ];
            }
            setTimeout(() => {
              initPopupOver();
            }, 500);
          }}
          let:row
        >
          {#if searchKeyByValue(columns, 'key', 'id') !== -1}
            <td
              class="text-muted first-col"
              width="20"
            >
              <div class="checkbox c-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="live_bidding"
                    checked={checkBoxSelected}
                    on:change={(event) => {
                      let oldSelectedTasks = selectedTasks;
                      if (event.target.checked) {
                        oldSelectedTasks.push({
                          id: row.id,
                          unitId: row.unitId,
                        });
                      } else {
                        oldSelectedTasks.splice(searchKeyByValue(selectedTasks, 'id', row.id), 1);
                      }
                      selectedTasks = oldSelectedTasks;
                    }}
                    value="1"
                  />
                  <span class="check-img"></span>
                </label>
              </div>
            </td>
          {/if}

          {#if searchKeyByValue(columns, 'key', 'priority') !== -1}
            <td
              class="text-muted"
              width="20"
            >
              <DropDown
                showTitle={false}
                showIcon={true}
                checkbox={false}
                deleteSelected={false}
                active={true}
                titleChanged={true}
                value={row.priority}
                extraClass={getValueBySearchValue(
                  configItem.priority,
                  'id',
                  row.priority,
                  'extraClass',
                )}
                icon={getValueBySearchValue(configItem.priority, 'id', row.priority, 'icon')}
                title={getValueBySearchValue(configItem.priority, 'id', row.priority, 'name')}
                defaultTitle="Priority"
                on:onSelect={(item) => {
                  client
                    .taskChangePriority({
                      priority: item.detail.id,
                      tasks: [{ id: row.id }],
                    })
                    .then(async (result) => {
                      if (
                        extraFilter.priority.length > 0 &&
                        extraFilter.priority.filter((iitem) => iitem.id == item.detail.id).length ==
                          0
                      ) {
                        selectedTasks = [];
                        filterData();
                      }
                      datatableRef.changeData(
                        {
                          id: row.id,
                          priority: item.detail.id,
                        },
                        'id',
                      );
                    });
                }}
                option={configItem.priority}
                Style="select-block priority-dropdown"
              />
            </td>
          {/if}

          <!-- Risk Rank column -->
          {#if searchKeyByValue(columns, 'key', 'riskRank') !== -1}
            <td
              class="text-muted"
              width="20"
            >
              <DropDown
                showTitle={false}
                showIcon={true}
                checkbox={false}
                deleteSelected={false}
                active={true}
                titleChanged={true}
                value={row.riskRank}
                extraClass={getValueBySearchValue(
                  configItem.riskRank,
                  'id',
                  row.riskRank,
                  'extraClass',
                )}
                icon={getValueBySearchValue(configItem.riskRank, 'id', row.riskRank, 'icon')}
                title={getValueBySearchValue(configItem.riskRank, 'id', row.riskRank, 'name')}
                defaultTitle="Risk Rank"
                on:onSelect={(item) => {
                  client
                    .taskRiskRank({
                      riskRank: item.detail.id,
                      tasks: [{ id: row.id }],
                    })
                    .then(() => {
                      if (
                        !!extraFilter.taskRiskRankType.length &&
                        !extraFilter.taskRiskRankType?.find?.(
                          (fItem) => fItem.id === item.detail.id,
                        )
                      ) {
                        selectedTasks = [];
                        filterData();
                      }
                      datatableRef.changeData(
                        {
                          id: row.id,
                          riskRank: item.detail.id,
                        },
                        'id',
                      );
                    });
                }}
                option={configItem.riskRank}
                Style="select-block risk-rank-dropdown"
              />
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'unitName') !== -1}
            <td
              class="text-muted"
              width="120">{row.unitName}</td
            >
          {/if}
          {#if searchKeyByValue(columns, 'key', 'name') !== -1}
            <td class="text-muted text-nowrap">
              <button
                type="button"
                class="bg-transparent border-0 color-blue text-start text-break px-0 clone_popup"
                data-bs-placement="top"
                data-bs-toggle="popover"
                data-bs-trigger="hover focus"
                data-bs-content={row.name +
                  (row.parentId > 0 ? ' (Sub task of: ' + row.parentName + ')' : '')}
                on:click={() => {
                  var elements = document.querySelectorAll('.popover.show');
                  elements.forEach(function (el) {
                    el.remove();
                  });
                  editTask(row.id);
                }}
              >
                <span
                  class="column-unit-name"
                  style="max-width:{availableWidth}px">{row.name}</span
                >
                {#if row.subTaskCount > 0}
                  <img
                    alt=""
                    class="icon-14 ms-2 me-1"
                    src="/images/checklist.svg"
                  />
                  <span class="align-middle position-relative sub-task-count"
                    >{row.subTaskCount}</span
                  >
                {/if}
                {#if row.parentId > 0}
                  <img
                    alt=""
                    class="icon-14 ms-2 me-1"
                    src="/images/subtask.svg"
                  />
                {/if}
              </button>
            </td>
          {/if}

          {#if searchKeyByValue(columns, 'key', 'progress') !== -1}
            <td
              class="text-muted"
              width="120"
            >
              <ProgressBar
                progressPer={row.progress}
                progressPerValue={row.progress}
              />
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'purpose') !== -1}
            <td class="text-muted">
              <button
                type="button"
                class="bg-transparent border-0 text-start text-break px-0 clone_popup"
                data-bs-placement="top"
                data-bs-toggle="popover"
                data-bs-trigger="hover focus"
                data-bs-content={row.purpose}
                on:click={() => {
                  var elements = document.querySelectorAll('.popover.show');
                  elements.forEach(function (el) {
                    el.remove();
                  });
                  editTask(row.id);
                }}
              >
                <span
                  class="column-unit-name"
                  style="max-width:{availableWidth}px">{row.purpose}</span
                >
              </button>
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'requirement') !== -1}
            <td class="text-muted">
              <button
                type="button"
                class="bg-transparent border-0 text-start text-break px-0 {row.requirement != ''
                  ? 'clone_popup'
                  : ''}"
                data-bs-placement="top"
                data-bs-toggle="popover"
                data-bs-trigger="hover focus"
                data-bs-content={row.requirement}
                on:click={() => {
                  var elements = document.querySelectorAll('.popover.show');
                  elements.forEach(function (el) {
                    el.remove();
                  });
                  editTask(row.id);
                }}
              >
                <span
                  class="column-unit-name"
                  style="max-width:{availableWidth}px">{row.requirement}</span
                >
              </button>
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'responsibleParty') !== -1}
            <td
              class="text-muted"
              width="120">{extraFilter.taskType == 2 ? '' : row.responsiblePartyLabel}</td
            >
          {/if}
          {#if searchKeyByValue(columns, 'key', 'assigneeUserName') !== -1}
            <td
              class="text-muted"
              width="120">{row.assigneeUserName}</td
            >
          {/if}
          {#if searchKeyByValue(columns, 'key', 'collaboratorName') !== -1}
            <td
              class="text-muted"
              width="120">{row.collaboratorName}</td
            >
          {/if}

          {#if searchKeyByValue(columns, 'key', 'clientName') !== -1}
            <td
              class="text-muted"
              width="120"
            >
              <button
                type="button"
                class="bg-transparent border-0 color-blue text-start text-break px-0 user-name"
                on:click={() => {
                  showClientModal(row.clientId);
                }}
              >
                {row.clientName}
              </button>
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'clientFundProfileName') !== -1}
            <td
              class="text-muted"
              width="120"
            >
              <button
                type="button"
                class="bg-transparent border-0 color-blue text-start"
                on:click={() => {
                  showClientModal(row.clientId, row.clientFundProfileId);
                }}
              >
                {row.clientFundProfileName}
              </button>
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'unitProjectName') !== -1}
            <td
              class="text-muted"
              width="120">{row.unitProjectName}</td
            >
          {/if}
          {#if searchKeyByValue(columns, 'key', 'openDate') !== -1}
            <td
              class="text-muted text-nowrap"
              width="130"
            >
              <button
                class="form-control input taskdate {searchKeyByValue(
                  heighlightTaskIds,
                  'id',
                  row.id,
                ) !== -1 && heighlightType == 'openDate'
                  ? 'shake-column'
                  : ''}"
                on:click={() =>
                  openDueDateModal.show({
                    comeFrom: 'list',
                    dateType: 'openDate',
                    date: row.openDateDb,
                    tasks: [{ id: row.id }],
                  })}
              >
                <img
                  class="img-calendar icon-16"
                  alt=""
                  src="/images/calendar.svg"
                />
                {row.openDate}
              </button>
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'dueDate') !== -1}
            <td
              class="text-muted text-nowrap"
              width="130"
            >
              <button
                class="form-control input taskdate {searchKeyByValue(
                  heighlightTaskIds,
                  'id',
                  row.id,
                ) !== -1 && heighlightType == 'dueDate'
                  ? 'shake-column'
                  : ''}"
                on:click={() =>
                  openDueDateModal.show({
                    comeFrom: 'list',
                    dateType: 'dueDate',
                    date: row.dueDateDb,
                    tasks: [{ id: row.id }],
                  })}
              >
                <img
                  class="img-calendar icon-16"
                  alt=""
                  src="/images/calendar.svg"
                />
                {row.dueDate}
              </button>
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'status') !== -1}
            <td width="90">
              <DropDown
                showIcon={false}
                checkbox={false}
                deleteSelected={false}
                active={true}
                titleChanged={true}
                value={row.status}
                extraClass={`td-status-${row.status}`}
                title={getValueBySearchValue(configItem.allTaskStatus, 'id', row.status, 'name')}
                defaultTitle={row.statusLabel}
                on:onSelect={(item) => {
                  client
                    .taskChangeStatus({
                      tasks: [{ id: row.id }],
                      status: item.detail.id,
                    })
                    .then(() => {
                      if (
                        (!!extraFilter.task_category.length &&
                          !extraFilter.task_category?.find?.(
                            (fItem) => fItem.id === item.detail.id,
                          )) ||
                        item.detail.id ===
                          configItem.allTaskStatus.find(
                            (statusItem) => statusItem.name === 'Complete',
                          )?.id ||
                        item.detail.id ===
                          configItem.allTaskStatus.find((statusItem) => statusItem.name === 'Open')
                            ?.id
                      ) {
                        selectedTasks = [];
                        filterData();
                      }
                      datatableRef.changeData(
                        {
                          id: row.id,
                          status: item.detail.id,
                        },
                        'id',
                      );
                    })
                    .catch((err) => {
                      showDialog({
                        message: err.message,
                        isHtmlMessage: true,
                      });
                    });
                }}
                titleStyle="color: white !important;"
                option={configItem.allTaskStatus.filter((item) => ![3].includes(item.id))}
                Style="td-status-{row.status}"
              />
            </td>
          {/if}
          <!-- Compliance status dropdown -->
          {#if searchKeyByValue(columns, 'key', 'complianceStatus') !== -1}
            <td width="90">
              <DropDown
                showIcon={false}
                checkbox={false}
                deleteSelected={false}
                active={true}
                titleChanged={true}
                value={row.complianceStatus}
                extraClass={`td-compliance-${row.complianceStatus}`}
                title={getValueBySearchValue(
                  configItem.allComplianceStatus,
                  'id',
                  row.complianceStatus,
                  'name',
                )}
                defaultTitle={configItem.allComplianceStatus.find(
                  (item) => item.id === row.complianceStatus,
                )?.name}
                on:onSelect={(item) => {
                  client
                    .taskComplianceStatus({
                      tasks: [{ id: row.id }],
                      complianceStatus: item.detail.id,
                    })
                    .then(() => {
                      if (
                        !!extraFilter.taskComplianceStatusType.length &&
                        !extraFilter.taskComplianceStatusType?.find?.(
                          (fItem) => fItem.id === item.detail.id,
                        )
                      ) {
                        selectedTasks = [];
                        filterData();
                      }
                      datatableRef.changeData(
                        {
                          id: row.id,
                          complianceStatus: item.detail.id,
                        },
                        'id',
                      );
                      selectedTasks = [];
                    })
                    .catch((err) => {
                      showDialog({
                        message: err.message,
                        isHtmlMessage: true,
                      });
                    });
                }}
                titleStyle="color: white !important;"
                option={configItem.allComplianceStatus}
                Style="td-compliance-{row.complianceStatus}"
              />
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'completeDate') !== -1}
            <td
              class="text-muted text-nowrap"
              width={row.completeDate != '' ? '130' : '90'}
            >
              {#if row.completeDate != ''}
                <button
                  class="form-control input taskdate {searchKeyByValue(
                    heighlightTaskIds,
                    'id',
                    row.id,
                  ) !== -1 && heighlightType == 'completeDate'
                    ? 'shake-column'
                    : ''}"
                  on:click={() =>
                    openDueDateModal.show({
                      comeFrom: 'list',
                      dateType: 'completeDate',
                      date: row.completeDateDb,
                      tasks: [{ id: row.id }],
                    })}
                >
                  <img
                    class="img-calendar icon-16"
                    alt=""
                    src="/images/calendar.svg"
                  />
                  {row.completeDate}
                </button>
              {/if}
            </td>
          {/if}
          {#if searchKeyByValue(columns, 'key', 'completeBy') !== -1}
            <td
              class="text-muted"
              width="80"><span>{row.completeUserName}</span></td
            >
          {/if}
          {#if searchKeyByValue(columns, 'key', 'clone') !== -1}
            <td
              class="text-muted"
              width="20"
            >
              <button
                type="button"
                data-bs-placement="top"
                data-bs-toggle="popover"
                data-bs-trigger="hover focus"
                data-bs-content="clone"
                class="bg-transparent border-0 color-blue clone_popup"
                on:click={() => {
                  showDialog({
                    type: 'confirm',
                    title: '',
                    message: 'Are you sure ?',
                    okFunc: () => {
                      client.taskClone({ id: row.id }).then(async (result) => {
                        selectedTasks = [];
                        filterData();
                        editTask(result.data.taskId, 'clone');
                      });
                    },
                  });
                }}
              >
                <img
                  class="icon-16"
                  alt=""
                  src="/images/copy.svg"
                />
              </button>
            </td>
          {/if}
        </DataTable>
      {/if}
    </div>
  </div>
</div>

<EditTaskModal bind:this={editTaskModal} />
<AddTaskModal bind:this={addTaskModal} />

<TaskReasonModal
  bind:this={taskReasonModal}
  handleClick={(params) => {
    //delete task
    if (selectedTypeId == 2) {
      client
        .taskDelete({
          tasks: selectedTasks,
          reason: params.reason,
          assignType,
          comeFrom: comeFromDetail ? 'detail' : '',
        })
        .then(async (result) => {
          selectedTasks = [];
          filterData();
          if (editTaskModal != undefined) {
            editTaskModal.hide();
          }
        })
        .catch((err) => {
          showDialog({ message: err.message });
        });
    }
    if (selectedTypeId == 6) {
      client
        .taskRemoveReview({
          tasks: selectedTasks,
          reason: params.reason,
          comeFrom: comeFromDetail ? 'detail' : '',
        })
        .then(async (result) => {
          selectedTasks = [];
          filterData();
          if (editTaskModal != undefined) {
            editTaskModal.hide();
          }
        })
        .catch((err) => {
          showDialog({ message: err.message, isHtmlMessage: true });
        });
    }
    if (selectedTypeId == 7) {
      client
        .taskReviewComplete({
          tasks: selectedTasks,
          reason: params.reason,
          comeFrom: comeFromDetail ? 'detail' : '',
        })
        .then(async (result) => {
          selectedTasks = [];
          filterData();
          if (editTaskModal != undefined) {
            editTaskModal.hide();
          }
        })
        .catch((err) => {
          showDialog({ message: err.message, isHtmlMessage: true });
        });
    }
    comeFromDetail = false;
  }}
/>

<TaskChangeAssignee
  bind:this={taskChangeAssigneeModal}
  handleClick={(params) => {
    client
      .taskChangeAssignee({
        tasks: selectedTasks,
        assignType,
        assigneeUserId: params.assigneeUserId,
        reason: params.reason,
      })
      .then(async (result) => {
        selectedTasks = [];
        filterData();
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  }}
/>
<OpenDueDateModal
  requestFrom="taskList"
  bind:this={openDueDateModal}
  success={() => {
    filterData();
  }}
/>

<InitialBoardDateModal
  bind:this={initialBoardDateModal}
  success={() => filterData()}
/>

<ChangePriorityModal
  bind:this={changePriorityModal}
  success={(params) => {
    filterData();
  }}
/>

<ChangeRiskRankModal
  bind:this={changeRiskRankModal}
  success={() => filterData()}
/>

<ChangeTaskStatusModal
  bind:this={changeTaskStatusModal}
  success={() => filterData()}
/>

<ChangeComplianceStatusModal
  bind:this={changeComplianceStatusModal}
  handleClick={({ complianceTaskId, reason }) => {
    client
      .taskComplianceStatus({
        tasks: selectedTasks,
        complianceStatus: complianceTaskId,
        complianceUpdateReason: reason,
      })
      .then(() => {
        selectedTasks = [];
        filterData();
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  }}
/>

<style lang="scss">
  .top-menu-filter {
    border-bottom: 1px solid $input-border-color;
    padding: 0.5rem 1rem;
  }

  .right-action-content {
    display: flex;

    flex: 0 0 435px;
    min-width: 435px;
  }
  @media (min-width: 1300px) and (max-width: 1600px) {
    .right-action-content {
      flex: 0 0 435px !important;
      min-width: 435px !important;
    }
  }
</style>
